/* ════════════════════════════════════════════════════════════════
   retard-cart.js — brand AJAX cart drawer (retard-mode).

   Self-contained: uses Shopify's standard cart AJAX API
   (/cart/add.js, /cart.js, /cart/change.js). No dependency on the
   retro PROGRAMS cart. Falls back to a normal POST if anything throws.

   Wires:
     - any <form data-ajax-cart> submit  → add without reload + open drawer
     - any [data-cart-toggle]            → open the drawer
     - free-shipping progress, qty steppers, remove, subtotal, checkout
   ════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (!document.body.classList.contains('retard-mode')) return;

  var FREE_SHIP_CENTS = 9900; // $99 free U.S. shipping threshold (USD base)
  // Presentment-currency aware (Shopify Markets). For a USD shopper rate===1 and
  // these reduce to the old whole-dollar "$" output — so the US view is unchanged.
  var curCode = function () { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; };
  var curRate = function () { var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate); return (r && r > 0) ? r : 1; };
  var fmt = function (c) { // c = presentment subunits (cart.js cents)
    var a = (Number(c) || 0) / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: curCode(), minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(a); }
    catch (e) { return '$' + Math.round(a).toLocaleString(); }
  };
  var fmtUsd = function (usdCents) { return fmt((Number(usdCents) || 0) * curRate()); }; // a USD threshold → buyer's currency
  var baseCents = function (cart) { return cart.total_price / curRate(); };              // presentment total → USD base
  var $ = function (s, r) { return (r || document).querySelector(s); };

  var drawer, scrim, built = false;

  function build() {
    if (built) return;
    scrim = document.createElement('div');
    scrim.className = 'rc-scrim';
    scrim.addEventListener('click', close);

    drawer = document.createElement('aside');
    drawer.className = 'rc-drawer';
    drawer.setAttribute('aria-label', 'Cart');
    drawer.innerHTML =
      '<div class="rc-head"><b id="rc-title">YOUR CART</b><button class="rc-x" aria-label="Close">✕</button></div>' +
      '<div class="rc-added" id="rc-added"></div>' +
      '<div class="rc-ship" id="rc-ship"></div>' +
      '<div class="rc-lines" id="rc-lines"></div>' +
      '<div class="rc-foot">' +
        '<div class="rc-subt"><span>SUBTOTAL</span><span id="rc-subt">' + fmt(0) + '</span></div>' +
        '<div class="rc-trust"><span>✓ FREE SHIP ' + fmtUsd(FREE_SHIP_CENTS) + '+</span><span>✓ VERIFIED</span><span>✓ 30-DAY RETURNS</span><span>✓ SECURE CHECKOUT</span></div>' +
        '<a class="rc-checkout" href="/checkout">CHECKOUT →</a>' +
      '</div>';
    document.body.appendChild(scrim);
    document.body.appendChild(drawer);
    drawer.querySelector('.rc-x').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    built = true;
  }

  function show() { build(); scrim.classList.add('open'); drawer.classList.add('open'); }
  function close() { if (drawer) { scrim.classList.remove('open'); drawer.classList.remove('open'); } }

  function syncCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (e) { e.textContent = n; });
  }

  function render(cart, addedTitle) {
    build();
    $('#rc-title').textContent = 'YOUR CART · ' + cart.item_count;
    syncCount(cart.item_count);
    $('#rc-subt').textContent = fmt(cart.total_price);

    var added = $('#rc-added');
    if (addedTitle) {
      added.textContent = 'ADDED ✓  ' + addedTitle;
      added.classList.add('show');
      clearTimeout(window.__rcAdded);
      window.__rcAdded = setTimeout(function () { added.classList.remove('show'); }, 2600);
    }

    var bc = baseCents(cart);
    var left = Math.max(0, FREE_SHIP_CENTS - bc);
    var pct = Math.min(100, bc / FREE_SHIP_CENTS * 100);
    $('#rc-ship').innerHTML =
      (left > 0 ? ('ADD ' + fmtUsd(left) + ' FOR FREE U.S. SHIPPING') : '✓ FREE U.S. SHIPPING UNLOCKED') +
      '<div class="rc-bar"><i style="width:' + pct + '%"></i></div>';

    var lines = $('#rc-lines');
    if (!cart.items.length) {
      lines.innerHTML = '<div class="rc-empty">YOUR CART IS EMPTY</div>';
      return;
    }
    lines.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + it.image + '" alt="">' :
        '<span style="font-family:var(--font-display)">' + (it.product_title || '?').charAt(0) + '</span>';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '<div class="rc-line" data-line="' + (i + 1) + '">' +
        '<div class="rc-im">' + img + '</div>' +
        '<div><h5>' + it.product_title + '</h5>' +
        (variant ? '<div class="rc-meta">' + variant + '</div>' : '') +
        '<div class="rc-qty"><button data-q="-1">−</button><span>' + it.quantity + '</span><button data-q="1">+</button></div></div>' +
        '<div><div class="rc-rt">' + fmt(it.line_price) + '</div><button class="rc-rm" data-q="0">REMOVE</button></div>' +
        '</div>';
    }).join('');

    lines.querySelectorAll('.rc-line').forEach(function (row) {
      var line = row.getAttribute('data-line');
      var qty = cart.items[line - 1].quantity;
      row.querySelectorAll('[data-q]').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = parseInt(b.getAttribute('data-q'), 10);
          var next = d === 0 ? 0 : qty + d;
          change(line, next);
        });
      });
    });
  }

  function getCart(addedTitle) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart, addedTitle); show(); return cart; });
  }

  function change(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (cart) { render(cart); });
  }

  // intercept add-to-cart forms
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-ajax-cart]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'ADDING…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (item) { return getCart(item.product_title || 'ITEM'); })
      .catch(function () { f.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }, true);

  // open drawer from header cart / any toggle
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cart-toggle]');
    if (!t) return;
    e.preventDefault();
    getCart();
  });
})();
